import { useEffect } from 'react';

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  const isOpen = currentIndex !== null && images && images.length > 0;

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = originalOverflow || '';
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen) return null;

  const currentImage = images[currentIndex];
  const src = typeof currentImage === 'string' ? currentImage : currentImage?.src || currentImage?.url;
  const alt = typeof currentImage === 'object' ? currentImage?.alt || currentImage?.title || 'Galleri billede' : 'Galleri billede';
  const title = typeof currentImage === 'object' ? currentImage?.title : null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 select-none"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/80 hover:text-white p-3 text-2xl z-10 transition-colors cursor-pointer bg-stone-900/60 rounded-full w-12 h-12 flex items-center justify-center"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>

      {images.length > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrev();
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 z-10 transition-colors cursor-pointer bg-stone-900/60 rounded-full w-12 h-12 flex items-center justify-center hover:bg-stone-800"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true"></i>
        </button>
      )}

      <div
        className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center relative"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={alt}
          className="max-h-[80vh] max-w-full object-contain rounded-md shadow-2xl"
        />
        {(title || images.length > 1) && (
          <div className="mt-3 text-center text-white/90 text-sm font-medium">
            {title && <p className="text-base font-semibold">{title}</p>}
            <p className="text-xs text-white/60 mt-1">
              {currentIndex + 1} af {images.length}
            </p>
          </div>
        )}
      </div>

      {images.length > 1 && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3 z-10 transition-colors cursor-pointer bg-stone-900/60 rounded-full w-12 h-12 flex items-center justify-center hover:bg-stone-800"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}
